// import dependencies
import template from './button-group.html'

// export component object
export default {
  template: template,
  replace: true,
    props: {
        vertical: {
            type: Boolean,
            default: false
        },
    },
}



// WEBPACK FOOTER //
// ./src/components/button-group/index.js